import React from 'react';
import { Button, ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
const MenuStatus = ({docksSingleActionFn, title}) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
   setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
   if (anchorRef.current && anchorRef.current.contains(event.target)) {
     return;
   }
   setOpen(false);
  };

  function handleListKeyDown(event) {
   if (event.key === 'Tab') {
     event.preventDefault();
     setOpen(false);
   }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
   if (prevOpen.current === true && open === false) {
     anchorRef.current.focus();
   }

   prevOpen.current = open;
  }, [open]);
  return(
    <div className="screen-button-size">
      <Button
        ref={anchorRef}
        aria-controls={open ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        variant="contained"
        disableElevation={true}
        startIcon={<WarningIcon />}
        endIcon={<ArrowDropDownIcon />}
        size="small"
      >
        Pending
      </Button>
      <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{zIndex:'99'}}>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                  <MenuItem onClick={(event) => {handleClose(event); docksSingleActionFn('Publish')}}>Publish</MenuItem>
                  <MenuItem onClick={(event) => {handleClose(event); docksSingleActionFn('Reject')}}>Reject</MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  )
}
export default MenuStatus;
